import { isValid } from 'clients/Clients';
import { getVoucherCondition } from 'clients/PromoClient';
import { useEffect, useState } from 'react';
import { BeVoucherCondition } from 'types/voucher';
import { useDebounce } from 'utils/debounce';
import useCartStates from 'zustand-lib/useCart';

export const useGetVoucherCondition = ({ code }: { code: string }) => {
  const { cartData } = useCartStates();

  const [time, setTime] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [condition, setCondition] = useState<BeVoucherCondition>();

  const cartDebounce = useDebounce(cartData, 2000);

  const fetchData = () => {
    if (!code) return;

    return getVoucherCondition({ codes: [code] }).then((res) => {
      if (isValid(res)) {
        setCondition(res.data[0]);
      }
    });
  };

  useEffect(() => {
    if (time === 0) {
      setTime(1);
      return;
    }
    
    fetchData();
  }, [cartDebounce]);

  useEffect(() => {
    setIsLoading(true);
    fetchData()?.finally(() => {
      setIsLoading(false);
    });
  }, []);

  return {
    isLoading,
    condition,
    fetchData,
  };
};

